import EventEmitter from 'eventemitter3';
export class Button{
    
    scene:Phaser.Scene;
    group:Phaser.GameObjects.Group;

    text:Phaser.GameObjects.Text;
    sprite:Phaser.GameObjects.Image;

    emitter:EventEmitter = new EventEmitter();

    buttonSprite:string;
    buttonHighlightSprite:string|null = null;
    buttonPressedSprite:string|null = null;
    label:string|null = null;

    static buttonPressSfx:string|null = null;
    useDefaultButtonPressSfx:boolean = true;

    buttonPressDownScale:number = .98;
    constructor(scene:Phaser.Scene,buttonSprite:string , x:number, y:number, buttonConfig?)
    {
        this.scene = scene;
        this.group = this.scene.add.group({});

        this.buttonSprite = buttonSprite;
        let button = this.scene.add.image(x, y,buttonSprite);
        button.setInteractive();
        this.group.add(button);
        this.sprite = button;

        let text = this.scene.add.text(x, y, buttonConfig ? buttonConfig.text || '' : '', buttonConfig ? buttonConfig.style || undefined : undefined);
        text.setOrigin(0.5,0.5);
        this.group.add(text);
        this.text = text;

        button.on('pointover',this.onPointerOver,this);
        button.on('pointerdown',this.onPointerDown,this);
        button.on('pointerup',this.onPointerUp,this);
        button.on('pointerout',this.onPointerOut,this);

        button.on('pointerdown',this.pressDown,this);
        button.on('pointerup',this.pressUp,this);

        scene.input.on('pointerup', this.onInputUp,this);
    }

    private onPointerOver(){
        if(this.sprite.input.enabled){
            if(this.buttonHighlightSprite){
                this.sprite.setTexture(this.buttonHighlightSprite);
            }else{
                this.sprite.setTint(0x000000);
            }
        }
    }
    private onPointerDown(){
        if(this.sprite.input.enabled){
            if(this.buttonPressedSprite){
                this.sprite.setTexture(this.buttonPressedSprite);
            }else{
                this.sprite.setScale(this.buttonPressDownScale,this.buttonPressDownScale);
                this.text.setScale(this.buttonPressDownScale,this.buttonPressDownScale);
            }
            if(this.useDefaultButtonPressSfx && Button.buttonPressSfx){
                this.scene.sound.play(Button.buttonPressSfx);
            }
        }
        
    }

    private onPointerUp(){
        if(this.sprite.input.enabled){
            if(this.buttonHighlightSprite){
                this.sprite.setTexture(this.buttonHighlightSprite);
            }
            
            if(this.buttonPressedSprite==null)
            {
                this.sprite.setScale(1,1);
                this.text.setScale(1,1);
            }
        }
    }

    private onPointerOut(){
        if(this.sprite.input.enabled){
            if(this.buttonSprite ){
                this.sprite.setTexture(this.buttonSprite);
            }
            if(this.buttonPressedSprite==null)
            {
                this.sprite.setScale(1,1);
                this.text.setScale(1,1);
            }
    
            if(this.buttonHighlightSprite==null){
                this.sprite.setTint(0xffffff);
            }
        }
        
    }

    private onInputUp(){
        if(this.sprite.input.enabled){
            if(this.buttonHighlightSprite){
                this.sprite.setTexture(this.buttonHighlightSprite);
            }
            
            if(this.buttonPressedSprite==null)
            {
                this.sprite.setScale(1,1);
                this.text.setScale(1,1);
            }
        }
    }

    pressDown(){
        this.emitter.emit('buttondown');
    }

    pressUp(){
        this.emitter.emit('buttonup');
    }
}